<!-- 订单管理 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="addRepairOrder('')" v-if="permission.addRepairOrder">{{
                    permission.addRepairOrder
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">订单号</div>
                <el-input style="width: 250px" class="search-item" size="small" v-model="searchData.orderCode" placeholder="请输入订单号"></el-input>
                <div class="search-name">状态</div>
                <el-select v-model="searchData.state" placeholder="请选择" size="small" class="search-item">
                    <el-option v-for="item in states" :key="item.value" :label="item.value" :value="item.key"></el-option>
                </el-select>
                <div class="search-name">创建时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#F2F6FC' }" @cell-dblclick="handleDBClick">
                <el-table-column min-width="300" show-overflow-tooltip width="190px" prop="OrderCode" label="订单号"></el-table-column>
                <el-table-column min-width="100" show-overflow-tooltip prop="UserName" label="车主"></el-table-column>
                <el-table-column width="150" show-overflow-tooltip prop="OrderAmount" label="订单总金额(元)"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" label="是否确认">
                    <template slot-scope="scope">{{ scope.row.isUserConfirms | booleanHandle }}</template>
                </el-table-column>
                <el-table-column width="160" show-overflow-tooltip prop="CrateTime" label="创建时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="StateName" label="状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="RTypeName" label="预约类型"></el-table-column>
                <el-table-column label="来源" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.RSource == 0 ? '车主' : scope.row.RSource == 1 ? '车回佳' : '自主创建' }}</template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <!-- <el-button
                v-if="permission.see"
                title="查看详情"
                size="mini"
                type="text"
                @click="gotoDetails(scope.$index, scope.row)"
              >{{permission.see}}</el-button> -->
                            <el-button
                                v-if="!scope.row.IsPay && !scope.row.IsCancel && permission.editRepairOrder && scope.row.RSource == 2"
                                title="编辑订单"
                                size="mini"
                                type="text"
                                @click="addRepairOrder(scope.row.OrderId)"
                                >编辑</el-button
                            >
                            <el-button title="取消原因" size="mini" type="text" @click="viewClosedReason(scope.row.OrderId)" v-if="scope.row.IsCancel && permission.cancelReason">{{
                                permission.cancelReason
                            }}</el-button>
                            <el-button
                                v-if="(scope.row.OrderState == 0 || scope.row.OrderState == 3) && permission.cancel && !scope.row.IsCancel"
                                title="取消订单"
                                size="mini"
                                type="text"
                                @click="cancel(scope.$index, scope.row)"
                                >{{ permission.cancel }}</el-button
                            >
                            <el-button
                                v-if="scope.row.OrderState == 1 && permission.finish && scope.row.RSource == 2"
                                title="完成订单"
                                size="mini"
                                type="text"
                                @click="finishRepairOrder(scope.row)"
                                >{{ permission.finish }}</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog title="订单取消原因" :close-on-click-modal="false" :visible.sync="reasonDialogVisible" @close="reasonFormData = {}">
            <div class="dialog-content">
                <el-form :model="reasonFormData" ref="reasonForm" label-width="100px" size="mini" v-loading="formloading">
                    <el-form-item label="取消人类型：">
                        <label>{{ reasonFormData.operatorType }}</label>
                    </el-form-item>
                    <el-form-item label="取消人：">
                        <label>{{ reasonFormData.operatorName }}</label>
                    </el-form-item>
                    <el-form-item label="取消时间：">
                        <label>{{ reasonFormData.cancelTime }}</label>
                    </el-form-item>
                    <el-form-item label="取消原因：">
                        <label>{{ reasonFormData.cancelReason }}</label>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.sTime" :end="this.searchData.eTime"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        timePicker,
        breadcrumb,
        elTableColumn
    },
    name: '',
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            timeVisible: false,
            states: [], // 订单状态
            options: [],
            value: '',
            searchData: {
                EntpId: userMsg.EntpId,
                orderCode: '',
                state: null,
                userName: '',
                sTime: '',
                eTime: '',
                page: 1, // 当前页数
                limit: 15, // 每页限制条数
                key: '' //关键字查询
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            reasonDialogVisible: false,
            formloading: false,
            reasonFormData: {}
        };
    },
    mounted() {
        this.getTableData();
        this.getStates();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('ClientOrders');
    },
    filters: {
        stateHandle(value) {
            let val = Number(value);
            let result = '';
            switch (val) {
                case 0:
                    result = '等待车主确认';
                    break;
                case 1:
                    result = '等待车主确认';
                    break;
                case 3:
                    result = '车主取消订单';
                    break;
            }
            return result;
        }
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.sTime = timer.start;
            this.searchData.eTime = timer.end;
            this.handleSearch();
        },
        resetSearch() {
            this.searchData = {
                EntpId: this.userMsg.EntpId,
                orderCode: '',
                state: null,
                userName: '',
                sTime: '',
                eTime: '',
                page: 1, // 当前页数
                limit: this.commonPageSize, // 每页限制条数
                key: '' //关键字查询
            };
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/CustomerManagement/OrderList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        // 获取订单状态
        getStates() {
            this.$util
                .axiosGet({
                    url: '/api/CustomerManagement/GetOrdersStates',
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    let item = { value: '请选择', key: -1 };
                    data.unshift(item);
                    this.states = data;
                })
                .catch(() => {});
        },
        addRepairOrder(oid) {
            this.$router.push(`/repairMamage/editOrder?oId=${oid}`);
        },
        // gotoDetails(i, row) {
        //   this.$router.push(`/repairMamage/orderDetails?OrderId=${row.OrderId}`);
        // },
        cancel(i, row) {
            this.$prompt('请输入取消原因', '取消订单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /.{1,100}/,
                inputErrorMessage: '请输入100自以内的数字或文字！'
            })
                .then(({ value }) => {
                    this.$util
                        .axiosPost({
                            url: 'api/CustomerManagement/CancelOrder',
                            data: {
                                orderId: row.OrderId,
                                cancelReason: value,
                                operator: this.userMsg.EmployeeId
                            }
                        })
                        .then(res => {
                            this.$util.successMsg('取消订单成功');
                            this.getTableData();
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.$router.push(`/repairMamage/orderDetails?OrderId=${event.OrderId}`);
            }
        },
        //查看取消原因
        viewClosedReason(oid) {
            this.reasonDialogVisible = true;
            this.formloading = true;
            this.$util
                .axiosGet({
                    url: '/api/CustomerManagement/GetCancelReason?oid=' + oid,
                    hideLoading: true
                }) //data=true表示不启用遮罩层
                .then(result => {
                    if (result.errcode == 0) {
                        this.reasonFormData = result.data;
                    }
                    this.formloading = false;
                })
                .catch(err => {
                    this.reasonFormData = {};
                    this.formloading = false;
                });
        },
        finishRepairOrder(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要完成该维修单？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/CustomerManagement/FinishRepairOrder?orderId=${row.OrderId}`
                        })
                        .then(() => {
                            that.$util.successMsg('保存成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        }
    }
};
</script>
